import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Trash, EnvelopeSimple, Check } from "@phosphor-icons/react";

export default function AdminSubmissions() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);

  const load = () => api.get("/admin/contact").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const onDelete = async (id) => {
    if (!window.confirm("Delete this submission?")) return;
    await api.delete(`/admin/contact/${id}`);
    toast.success("Deleted");
    load();
  };

  const markRead = async (id) => {
    await api.patch(`/admin/contact/${id}/read`);
    load();
  };

  return (
    <div data-testid="admin-submissions">
      <h1 className="font-display text-3xl md:text-4xl font-black tracking-tighter">Partnership inquiries</h1>
      <p className="text-slate-600 mt-1">{items.length} total</p>

      <div className="mt-8 space-y-3">
        {items.length === 0 && (
          <div className="brutal-card rounded-3xl p-10 text-center text-slate-500">No submissions yet.</div>
        )}
        {items.map((s) => (
          <div key={s.id} className="brutal-card rounded-3xl p-5 md:p-6" data-testid={`submission-${s.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-[#FF6B9E] to-[#A78BFA] text-white flex items-center justify-center font-display font-black">
                  {s.name?.[0]?.toUpperCase() || "?"}
                </div>
                <div>
                  <div className="font-display text-lg font-black">{s.name}</div>
                  <div className="text-sm text-slate-600">{s.company || "—"} · {s.country}</div>
                </div>
              </div>
              <div className="flex flex-wrap items-center gap-2">
                {!s.read && <span className="sticker bg-[#FF6B9E] text-white border-[#FF6B9E]">New</span>}
                <span className="sticker">{s.interest_category}</span>
                <a href={`mailto:${s.email}`} data-testid={`email-${s.id}`} className="sticker"><EnvelopeSimple size={12} weight="bold" /> Reply</a>
                {!s.read && (
                  <button onClick={() => markRead(s.id)} data-testid={`mark-read-${s.id}`} className="sticker"><Check size={12} weight="bold" /> Mark read</button>
                )}
                <button onClick={() => onDelete(s.id)} data-testid={`delete-${s.id}`} className="sticker text-rose-600 border-rose-300"><Trash size={12} weight="bold" /></button>
              </div>
            </div>
            <p className="mt-4 text-sm text-slate-700 whitespace-pre-wrap leading-relaxed">{s.message}</p>
            <div className="mt-3 text-xs text-slate-500">{s.email} · {new Date(s.created_at).toLocaleString()}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
